import {RelatedLink} from "../utils";

export const esRelatedLinks: RelatedLink[] = [];
